// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*--------------------------------------------------------------
# Results Pagination Section
--------------------------------------------------------------*/
.S4kxbtN8QQL086ibQo9S {
  direction: ltr;
}
.S4kxbtN8QQL086ibQo9S nav {
  position: relative;
}
.S4kxbtN8QQL086ibQo9S ul {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0;
  margin: 0;
  list-style: none;
}
.S4kxbtN8QQL086ibQo9S li {
  margin: 0;
}
.S4kxbtN8QQL086ibQo9S li._BIUrHp8FLmL9h5VHA4w {
  color: #0C3058;
  padding: 8px 12px;
  user-select: none;
}
.S4kxbtN8QQL086ibQo9S li a, .S4kxbtN8QQL086ibQo9S li span {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 28px;
  height: 28px;
  color: #0C3058;
  text-decoration: none;
  border-radius: 8px;
  transition: all 0.3s ease;
  overflow: hidden;
}
.S4kxbtN8QQL086ibQo9S li a:hover, .S4kxbtN8QQL086ibQo9S li span:hover {
  color: #0068F5;
}
.S4kxbtN8QQL086ibQo9S li a:hover::after, .S4kxbtN8QQL086ibQo9S li span:hover::after {
  width: 100%;
}
.S4kxbtN8QQL086ibQo9S li a.XHxcKauSx0Tn2woh4bgs, .S4kxbtN8QQL086ibQo9S li span.XHxcKauSx0Tn2woh4bgs {
  color: #FFFFFF;
  font-weight: 500;
  background-color: #0068F5;
  font-size: 16px;
}
.S4kxbtN8QQL086ibQo9S li a.XHxcKauSx0Tn2woh4bgs::after, .S4kxbtN8QQL086ibQo9S li span.XHxcKauSx0Tn2woh4bgs::after {
  width: 100%;
  height: 3px;
}
.S4kxbtN8QQL086ibQo9S li a.S2qfxQFotkvkUEYvoUVy, .S4kxbtN8QQL086ibQo9S li span.S2qfxQFotkvkUEYvoUVy {
  color: color-mix(in srgb, var(--default-color), transparent 30%);
}
.S4kxbtN8QQL086ibQo9S li a.S2qfxQFotkvkUEYvoUVy:hover, .S4kxbtN8QQL086ibQo9S li span.S2qfxQFotkvkUEYvoUVy:hover {
  color: #0068F5;
}
.S4kxbtN8QQL086ibQo9S li a.S2qfxQFotkvkUEYvoUVy.jV4BiCGpFej5MZj36nfO, .S4kxbtN8QQL086ibQo9S li span.S2qfxQFotkvkUEYvoUVy.jV4BiCGpFej5MZj36nfO {
  opacity: 0.5;
  color: #8596AF;
}
.S4kxbtN8QQL086ibQo9S li a.S2qfxQFotkvkUEYvoUVy.jV4BiCGpFej5MZj36nfO i:hover, .S4kxbtN8QQL086ibQo9S li span.S2qfxQFotkvkUEYvoUVy.jV4BiCGpFej5MZj36nfO i:hover {
  color: #1E1E1E;
}
.S4kxbtN8QQL086ibQo9S li a.S2qfxQFotkvkUEYvoUVy i, .S4kxbtN8QQL086ibQo9S li span.S2qfxQFotkvkUEYvoUVy i {
  font-size: 22px;
  color: #0C3058;
}
.S4kxbtN8QQL086ibQo9S li a.S2qfxQFotkvkUEYvoUVy i:hover, .S4kxbtN8QQL086ibQo9S li span.S2qfxQFotkvkUEYvoUVy i:hover {
  color: #0068F5;
}
@media (max-width: 575px) {
  .S4kxbtN8QQL086ibQo9S ul {
    gap: 2px;
  }
  .S4kxbtN8QQL086ibQo9S li a {
    min-width: 32px;
    height: 32px;
    padding: 6px;
    font-size: 14px;
  }
  .S4kxbtN8QQL086ibQo9S li._BIUrHp8FLmL9h5VHA4w {
    padding: 6px 8px;
  }
}
@media (hover: none) {
  .S4kxbtN8QQL086ibQo9S li a::after {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./GeneralComponents/SearchResults/searchResults/resultsPagination/ResultsPagination.module.scss"],"names":[],"mappings":"AAAA;;+DAAA;AAGA;EACI,cAAA;AACJ;AACI;EACI,kBAAA;AACR;AAEI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;AAAR;AAGI;EACI,SAAA;AADR;AAGQ;EACI,cAAA;EACA,iBAAA;EACA,iBAAA;AADZ;AAIQ;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;AAFZ;AAIY;EACI,cAAA;AAFhB;AAIgB;EACI,WAAA;AAFpB;AAMY;EACI,cAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;AAJhB;AAOgB;EACI,WAAA;EACA,WAAA;AALpB;AASY;EACI,gEAAA;AAPhB;AASgB;EACI,cAAA;AAPpB;AAUgB;EACI,YAAA;EACA,cAAA;AARpB;AAWwB;EACI,cAAA;AAT5B;AAcgB;EACI,eAAA;EACA,cAAA;AAZpB;AAcoB;EACI,cAAA;AAZxB;AAmBI;EACI;IACI,QAAA;EAjBV;EAqBU;IACI,eAAA;IACA,YAAA;IACA,YAAA;IACA,eAAA;EAnBd;EAsBU;IACI,gBAAA;EApBd;AACF;AAwBI;EACI;IACI,aAAA;EAtBV;AACF","sourcesContent":["/*--------------------------------------------------------------\r\n# Results Pagination Section\r\n--------------------------------------------------------------*/\r\n.results-pagination {\r\n    direction: ltr;\r\n\r\n    nav {\r\n        position: relative;\r\n    }\r\n\r\n    ul {\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        gap: 7px;\r\n        padding: 0;\r\n        margin: 0;\r\n        list-style: none;\r\n    }\r\n\r\n    li {\r\n        margin: 0;\r\n\r\n        &.ellipsis {\r\n            color: #0C3058;\r\n            padding: 8px 12px;\r\n            user-select: none;\r\n        }\r\n\r\n        a, span {\r\n            position: relative;\r\n            display: flex;\r\n            align-items: center;\r\n            justify-content: center;\r\n            min-width: 28px;\r\n            height: 28px;\r\n            color: #0C3058;\r\n            text-decoration: none;\r\n            border-radius: 8px;\r\n            transition: all 0.3s ease;\r\n            overflow: hidden;\r\n\r\n            &:hover {\r\n                color: #0068F5;\r\n\r\n                &::after {\r\n                    width: 100%;\r\n                }\r\n            }\r\n\r\n            &.active {\r\n                color: #FFFFFF;\r\n                font-weight: 500;\r\n                background-color: #0068F5;\r\n                font-size: 16px;\r\n\r\n\r\n                &::after {\r\n                    width: 100%;\r\n                    height: 3px;\r\n                }\r\n            }\r\n\r\n            &.nav-btn {\r\n                color: color-mix(in srgb, var(--default-color), transparent 30%);\r\n\r\n                &:hover {\r\n                    color: #0068F5;\r\n                }\r\n\r\n                &.disabled {\r\n                    opacity: 0.5;\r\n                    color: #8596AF;\r\n\r\n                    i {\r\n                        &:hover {\r\n                            color: #1E1E1E;\r\n                        }\r\n                    }\r\n                }\r\n\r\n                i {\r\n                    font-size: 22px;\r\n                    color: #0C3058;\r\n\r\n                    &:hover {\r\n                        color: #0068F5;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    @media (max-width: 575px) {\r\n        ul {\r\n            gap: 2px;\r\n        }\r\n\r\n        li {\r\n            a {\r\n                min-width: 32px;\r\n                height: 32px;\r\n                padding: 6px;\r\n                font-size: 14px;\r\n            }\r\n\r\n            &.ellipsis {\r\n                padding: 6px 8px;\r\n            }\r\n        }\r\n    }\r\n\r\n    @media (hover: none) {\r\n        li a::after {\r\n            display: none;\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"results-pagination": `S4kxbtN8QQL086ibQo9S`,
	"ellipsis": `_BIUrHp8FLmL9h5VHA4w`,
	"active": `XHxcKauSx0Tn2woh4bgs`,
	"nav-btn": `S2qfxQFotkvkUEYvoUVy`,
	"disabled": `jV4BiCGpFej5MZj36nfO`
};
export default ___CSS_LOADER_EXPORT___;
